import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { HeartHandshake } from "lucide-react";
import { useProfile } from "@/context/ProfileContext";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER;
const KEY = "mb_calm_popup";
const DELAY_MS = 60000;

export const CalmPopup = () => {
  const { profile } = useProfile();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const hidden = pathname.startsWith("/admin") || pathname.startsWith("/influencer") || pathname.startsWith("/gift");

  useEffect(() => {
    if (!profile || hidden || sessionStorage.getItem(KEY)) return;
    const t = setTimeout(() => { setOpen(true); sessionStorage.setItem(KEY, "1"); }, DELAY_MS);
    return () => clearTimeout(t);
  }, [profile, hidden]);

  if (!profile || hidden) return null;
  const first = (profile.name || "").split(" ")[0];
  const msg = `Ciao Minime! Sono ${profile.name}, vorrei un consiglio personalizzato per il corredino del mio bimbo. C'è anche qualche novità in arrivo che posso mettere da parte?`;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md rounded-3xl bg-[#FDFBF9] border-[#EFE8E2]" data-testid="calm-popup">
        <div className="w-12 h-12 rounded-2xl bg-[#F9ECE9] text-[#C87D75] flex items-center justify-center">
          <HeartHandshake size={24} strokeWidth={1.6} />
        </div>
        <DialogTitle className="font-serif text-3xl text-[#2D2825] font-normal" data-testid="calm-popup-title">
          {first ? `${first}, prenditi il tuo tempo` : "Prenditi il tuo tempo"}
        </DialogTitle>
        <DialogDescription asChild>
          <div className="space-y-3 text-[#5C534E] leading-relaxed">
            <p>Non c'è nessuna fretta: guarda con calma, ripensaci e scegli i capi giusti per il tuo bimbo quando ti senti pronta. La tua lista ti aspetta.</p>
            <p>Se hai un dubbio su taglie o tessuti, scrivici su WhatsApp: ti diamo un consiglio personalizzato. E forse c'è qualcosa in arrivo che possiamo mettere da parte per te.</p>
          </div>
        </DialogDescription>
        <div className="flex flex-col gap-2 pt-2">
          {NUMBER && (
            <a href={`https://wa.me/${NUMBER}?text=${encodeURIComponent(msg)}`} target="_blank" rel="noreferrer" data-testid="calm-popup-whatsapp"
              onClick={() => setOpen(false)}
              className="h-12 rounded-full bg-[#25D366] text-white font-medium inline-flex items-center justify-center hover:brightness-95 transition-[filter]">
              Scrivici su WhatsApp
            </a>
          )}
          <button onClick={() => setOpen(false)} data-testid="calm-popup-close" className="h-11 rounded-full border-0 text-sm text-[#5C534E] hover:bg-[#F4EFEA] transition-colors">
            Continuo a guardare con calma
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
